import React from 'react'
import TextStylesButton from './TextStylesButton'

const TextStylesSchema = {
  marks: {
    Serif: ({attributes, children}) => <span {...attributes} style={{fontFamily: 'serif'}}>{children}</span>, // eslint-disable-line
    Caption: ({attributes, children}) => <span {...attributes} style={{fontSize: '0.875em', color: '#939597'}}>{children}</span>, // eslint-disable-line
    Light: ({attributes, children}) => <span {...attributes} style={{fontWeight: 'lighter'}}>{children}</span> // eslint-disable-line
  }
}

const styleTypes = Object.keys(TextStylesSchema.marks)

const hasTextStyles = state => {
  return state.marks.count() &&
    state.marks.some(mark => mark.type in TextStylesSchema.marks)
}

const hasTextStyle = (state, styleType) => {
  return state.marks.count() &&
    state.marks.some(mark => mark.type === styleType)
}

const onClickButton = (e, state, styleType) => {
  e.preventDefault()
  return onApply(state, styleType)
}

const onApply = (state, styleType) => {
  return state
    .transform()
    .toggleMark(styleType)
    .focus()
    .apply()
}

const TextStylesPlugin = options => {
  return {
    schema: TextStylesSchema
  }
}

export {
  styleTypes,
  hasTextStyle,
  hasTextStyles,
  onClickButton,
  TextStylesPlugin,
  TextStylesSchema,
  TextStylesButton
}



// WEBPACK FOOTER //
// ./src/components/TextStylesSlatePlugin/TextStylesSlatePluginContainer.js